import { z } from 'zod';
import { expectType } from './model.js';
import { zPostBase, zFullPostBase, EmptyPostBase } from './post.js';
export const MARKETPLACE_ITEM_CONDITIONS = ['new', 'excellent', 'good', 'fair', 'poor'];
export const DEFAULT_MARKETPLACE_ITEM_CONDITION = MARKETPLACE_ITEM_CONDITIONS[2];
export const conditionLabels = {
    new: 'New',
    excellent: 'Excellent',
    good: 'Good',
    fair: 'Fair',
    poor: 'Poor'
};
export const zMarketplaceItemFields = z.object({
    postType: z.literal('marketplaceItem'),
    price: z.number().gte(0),
    condition: z.enum(MARKETPLACE_ITEM_CONDITIONS),
    closed: z.boolean()
});
export const zMarketplaceItem = zPostBase.merge(zMarketplaceItemFields);
expectType({});
expectType({});
export const zFullMarketplaceItem = zFullPostBase.merge(zMarketplaceItemFields);
expectType({});
expectType({});
export const EmptyMarketplaceItem = {
    ...EmptyPostBase,
    postType: 'marketplaceItem',
    condition: DEFAULT_MARKETPLACE_ITEM_CONDITION,
    price: 0,
    closed: false
};
